import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { FaqPageTeaser } from '@cp-mx/common';
import { fetchFaqTeaser } from './FaqTeaserSlice';
import { FaqTeaserContentSelector } from './FaqTeaserContentSelector';

export function useFaqTeaser(): AbstractContentState<FaqPageTeaser> {
    return useCmsContent(fetchFaqTeaser, FaqTeaserContentSelector);
}
